
import { defineComponent } from 'vue'
import { appConfiguration } from '@/store/configuration'

export default defineComponent({
  setup() {
    return {
      ...appConfiguration.value?.content
    }
  }
})

